import { createReducer } from 'redux-create-reducer'
import type { TrackId } from 'types/track'
import {
  NESTING_LOAD,
  NESTING_LOAD_ERROR,
  NESTING_RESET,
  NESTING_TRACKS_LOAD_SUCCESS,
  NESTING_UPDATING,
  NESTING_UPDATING_ERROR,
  NESTING_UPDATING_SUCCESS,
} from '@disco/constants/ActionTypes'
import { TRACK_LOAD_BATCH } from '@disco/constants/ActionTypes'
export type TrackNestingState = {
  loading?: boolean
  loaded?: boolean
  error: string | null | undefined
  nested_ids?: TrackId[]
  updating?: boolean
}
export type NestingState = Record<TrackId, TrackNestingState>
const initialState: NestingState = {}
export const nestingReducer = createReducer<NestingState, any>(initialState, {
  [NESTING_LOAD](state, { id }) {
    const newState = { ...state }
    newState[id] = {
      loading: true,
      loaded: false,
      error: null,
    }
    return newState
  },

  [NESTING_LOAD_ERROR](state, { id, error }) {
    const newState = { ...state }
    newState[id] = {
      loading: false,
      loaded: false,
      error: error.message,
    }
    return newState
  },

  [NESTING_TRACKS_LOAD_SUCCESS](state, { id, nested_ids }) {
    const newState = { ...state }
    newState[id] = {
      loading: false,
      loaded: true,
      error: null,
      nested_ids: nested_ids,
    }
    return newState
  },

  [NESTING_UPDATING](state, { id }) {
    const newState = { ...state }
    newState[id] = { ...(state[id] ?? {}), updating: true, error: null }
    return newState
  },

  [NESTING_UPDATING_SUCCESS](state, { id }) {
    const newState = { ...state }
    newState[id] = {
      ...(state[id] ?? {}),
      updating: false,
      error: null,
    }
    return newState
  },

  [NESTING_UPDATING_ERROR](state, { id, error }) {
    const newState = { ...state }
    newState[id] = {
      ...(state[id] ?? {}),
      updating: false,
      error: error.message,
    }
    return newState
  },

  [NESTING_RESET]() {
    return {}
  },

  [TRACK_LOAD_BATCH](state, { list }) {
    const tracksWithNestedTracks = list.filter(
      track => track.nested_tracks?.length > 0,
    )

    if (tracksWithNestedTracks.length === 0) {
      return state
    }

    const newState = { ...state }

    for (const track of tracksWithNestedTracks) {
      newState[track.id] = {
        loading: false,
        loaded: true,
        error: null,
        nested_ids: track.nested_tracks.map(t => t.id),
      }
    }

    return newState
  },
})
